import { render, staticRenderFns } from "./listado_ventas_new.vue?vue&type=template&id=1c7e5a32"
import script from "./listado_ventas_new.vue?vue&type=script&lang=js"
export * from "./listado_ventas_new.vue?vue&type=script&lang=js"
import style0 from "./listado_ventas_new.vue?vue&type=style&index=0&id=1c7e5a32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports